import { supabase } from "@/integrations/supabase/client";

export type NotificationKind =
  | "cost_alert"
  | "ab_winner"
  | "auto_pause"
  | "deletion_request"
  | "generic";

export type NotificationRow = {
  id: string;
  user_id: string;
  kind: NotificationKind;
  title: string;
  body: string | null;
  link: string | null;
  metadata: Record<string, unknown>;
  read_at: string | null;
  created_at: string;
};

/**
 * Create a notification for the current user. Safe to call from anywhere
 * client-side (RLS restricts insert to auth.uid() = user_id).
 *
 * Server/edge code should use the service role to insert with explicit user_id.
 */
export async function createNotification(input: {
  kind: NotificationKind;
  title: string;
  body?: string;
  link?: string;
  metadata?: Record<string, unknown>;
}): Promise<void> {
  const { data: auth } = await supabase.auth.getUser();
  const userId = auth?.user?.id;
  if (!userId) return;
  await supabase.from("notifications").insert([
    {
      user_id: userId,
      kind: input.kind,
      title: input.title,
      body: input.body ?? null,
      link: input.link ?? null,
      metadata: (input.metadata ?? {}) as never,
    },
  ]);
}
